import Text from "@components/atoms/Text";
import styles from "./FAQItem.module.scss";

type FAQ = {
  question: string;
  answer: string;
};

export function FAQItem({ faq }: { faq: FAQ }) {
  return (
    <article className={styles.card}>
      <Text level="h3" className={styles.question}>
        {faq.question}
      </Text>
      <Text level="p" className={styles.answer}>
        {faq.answer}
      </Text>
    </article>
  );
}
